import React from 'react';
import { observer } from 'mobx-react';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import { withConditional } from 'legacyComponents/hoc/conditional';
import { media } from 'legacyComponents/styled/styleUtils';

import { IconColumn } from 'apps/repository/styles';
import { Icon } from 'components';
import { conf } from 'apps/repository/config.yaml';

export const FileIcon = observer(({ fileInfo, addingFolder }) => {
  const { operationColors } = conf;
  const { reference } = fileInfo;
  const color = reference.opType && operationColors[reference.opType];
  const spinner = reference.opType && reference.opType === 'WIP';
  const { isFolder, renaming } = reference;
  const icon = (
    <Icon
      name={
        spinner ? 'loop' : renaming ? 'edit' : isFolder ? 'folder' : 'document'
      }
      size='medium'
    />
  );
  return (
    <IconColumn>
      <OperationMark condition={!!reference.opType} color={color} />
      <FileIconStyled
        addingFolder={addingFolder}
        animation={spinner}
        opType={reference.opType && reference.opType}
      >
        {icon}
      </FileIconStyled>
    </IconColumn>
  );
});

const FolderIcon = styled.div`
  width: 52px;
  height: 52px;
  color: ${props =>
    props.opType === 'REMOVE'
      ? props.theme.color.wfOrange
      : props.opType === 'RENAME'
      ? props.theme.color.wfYellow
      : props.opType === 'ADD'
      ? props.theme.color.wfGreen
      : props.theme.color.wfBlue};
  margin-top: 8px;
  margin-left: 19px;
  border-radius: 100%;
  text-align: center;
  line-height: 46px;
  cursor: pointer;
  background-color: ${props =>
    props.opType === 'REMOVE'
      ? props.theme.color.wfOrange100
      : props.opType === 'RENAME'
      ? props.theme.color.wfYellow200
      : props.opType === 'ADD'
      ? props.theme.color.wfGreen200
      : props.theme.color.wfBlue100};
  ${media.m`
    margin-left: 14px;
  `};
`;

const blink = keyframes`
  from {
    color: ${props => props.theme.color.wfGrey500};
   }
   to {
    color: ${props => props.theme.color.wfWhite};
   }
`;

const blinkMixin = css`
  animation: ${blink} 0.75s infinite;
`;

const OperationMark = withConditional(styled.span`
  width: 3px;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: ${props =>
    props.color ? props.color : props.theme.color.wfGrey500};
`);

const FileIconStyled = styled(FolderIcon)`
  ${props => props.animation && blinkMixin};
`;

FileIcon.propTypes = {
  fileType: PropTypes.string,
  renaming: PropTypes.bool,
};
